import script from "./Puzzle.vue?vue&type=script&lang=js"
export * from "./Puzzle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__